// SPDX-License-Identifier: Apache-2.0

import PerunMessage from "./PerunMessage";
import { MessageType, MessageTypeName } from "./messageTypes";
import { jsonMember, jsonObject } from "typedjson";
import {
  ChannelAsset,
  deserializeChannelAsset,
  serializeChannelAsset,
} from "./types/channelState";
import { jsonCKBTxMember } from "./types/nervosTransaction";
import { TransactionWithScriptGroups } from "./types/nervosTransactionTypes";

// LPSubmitSigned submits the owner-signed CKB tx (witnesses populated on
// signedTx.tx_view). CKB only — there is no ETH equivalent. hub MUST be set so
// the backend notifies the hub after it broadcasts.
@jsonObject()
export default class LPSubmitSigned extends PerunMessage {
  @jsonMember({
    deserializer: deserializeChannelAsset,
    serializer: serializeChannelAsset,
  })
  asset: ChannelAsset;
  @jsonCKBTxMember() signedTx: TransactionWithScriptGroups;
  @jsonMember(String) hub: string;

  constructor(
    asset: ChannelAsset,
    signedTx: TransactionWithScriptGroups,
    hub: string,
  ) {
    super();
    this.asset = asset;
    this.signedTx = signedTx;
    this.hub = hub;
  }

  messageType(): MessageType {
    return LPSubmitSigned;
  }

  messageTypeName(): MessageTypeName {
    return "LPSubmitSigned";
  }
}
